// Комментарий на русском: утилиты мессенджера вынесены из `MessagesPageClient.tsx`,
// чтобы уменьшить размер страницы и сделать код проще для поддержки.

export const POLL_CONVERSATIONS_MS = 15000;
export const POLL_MESSAGES_MS = 2500;

// Комментарий на русском: защита от дублей (гонка optimistic-send vs poll). Оставляем последнюю версию по id.
export const dedupeLastById = <T extends { id: number }>(items: T[]) => {
  const idx = new Map<number, number>();
  const out: T[] = [];
  for (const it of items) {
    const i = idx.get(it.id);
    if (i === undefined) {
      idx.set(it.id, out.length);
      out.push(it);
    } else {
      out[i] = it;
    }
  }
  return out;
};

export const formatDialogTime = (dateString: string) => {
  const date = new Date(dateString);
  const now = new Date();
  const diffDays = Math.floor((now.getTime() - date.getTime()) / (1000 * 60 * 60 * 24));
  if (diffDays === 0) return date.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
  if (diffDays === 1) return 'Вчера';
  return date.toLocaleDateString('ru-RU');
};

// Комментарий на русском: генерируем client_id для идемпотентной отправки (устраняет дубли в UI).
export const makeClientId = () => {
  try {
    const c = (globalThis as any)?.crypto;
    if (c?.randomUUID) return String(c.randomUUID());
  } catch {}
  return `c_${Date.now()}_${Math.random().toString(16).slice(2)}`;
};


